import { FC } from 'react';
import { useField } from 'react-final-form';

import { FormCheckbox } from 'src/components/FormCheckbox/FormCheckbox';
import { FormTextArea } from 'src/components/FormTextArea/FormTextArea';
import { FormTextField } from 'src/components/FormTextField/FormTextField';
import { Section } from 'src/components/Section/Section';
import { FormTownSelect } from 'src/components/TownSelect/FormTownSelect';

export const AdministratorBuildingFields: FC = () => {
  const locationDisabled = !!useField<number | undefined>('id').input.value;
  const enabled = useField<boolean>('enabled').input.value;

  return (
    <>
      <Section
        title={locationDisabled ? 'Город' : 'Выберите город'}
        testId='administratorTown'
      >
        <FormTownSelect
          name='town'
          dataTestId='administratorTownSelect'
          disabled={locationDisabled}
        />
      </Section>
      <Section title='Укажите адрес' testId='administratorBuildingAddress'>
        <FormTextField
          name='address'
          size='medium'
          label='Адрес'
          dataTestId='administratorBuildingAddressField'
          required
          fullWidth
        />
      </Section>
      <Section
        title='Выберите доступность'
        testId='administratorBuildingEnabled'
      >
        <FormCheckbox
          name='enabled'
          label='Доступно пользователям'
          dataTestId='administratorBuildingEnabledCheckbox'
        />
        <FormTextArea
          name='disabledReason'
          disabled={enabled}
          placeholder='Опишите причину недоступности'
          fullWidth
        />
      </Section>
      <Section title='Укажите атрибуты' testId='administratorAttributes'>
        <FormCheckbox
          name='isTestData'
          label='Для тестирования'
          dataTestId='administratorBuildingIsTestData'
        />
      </Section>
    </>
  );
};
